import { render, staticRenderFns } from "./MagazzinoScadenziarioListPage.vue?vue&type=template&id=80a4adf0"
import script from "./MagazzinoScadenziarioListPage.vue?vue&type=script&lang=js"
export * from "./MagazzinoScadenziarioListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports